import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import ODMTabs from "../../components/odm/ODMTabs";

const OneDayMembership = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: One Day Membership">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <ODMTabs userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default OneDayMembership;
